import React from 'react';
import { Form } from 'reactstrap';
import { Radio, InputText, Checkbox } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { FormInput } from '../../types';

interface FilterContentProps {
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
}

export const FilterContent: React.FC<FilterContentProps> = ({
  formData,
  formErrors,
  onChangeFormInput,
}) => {
  const optionFilter = [{ label: 'Nome', value: 'name' }];

  return (
    <div className="filter-modal-content">
      <Form noValidate={true} onSubmit={(e): void => e.preventDefault()}>
        <span className="filter-name">Filtrar por:</span>
        <Checkbox
          name="historical"
          label="Base histórica"
          checked={formData[FormInput.historical] === 'true'}
          onChange={e =>
            onChangeFormInput(FormInput.historical)(e.target.checked === true ? 'true' : 'false')
          }
        />
        <Radio
          options={optionFilter}
          name="filterSearch"
          style={{ fontSize: '21px' }}
          value={formData[FormInput.filterSearch]}
          onChange={e => onChangeFormInput(FormInput.filterSearch)(e.target.value)}
          error={formErrors.filterSearch && formErrors.filterSearch[0]}
        />
        {formData[FormInput.filterSearch] && (
          <InputText
            name="inputSearch"
            label={
              optionFilter.find(values => formData[FormInput.filterSearch] === values.value)
                ?.label ?? ''
            }
            placeholder={formData[FormInput.filterSearch] === 'name' ? 'Nome do evento' : ''}
            maxLength={30}
            value={formData[FormInput.inputSearch]}
            onChange={e => onChangeFormInput(FormInput.inputSearch)(e.target.value)}
            error={formErrors.inputSearch && formErrors.inputSearch[0]}
          />
        )}
      </Form>
    </div>
  );
};
